module.exports = __webpack_public_path__ + "static/studentsports_home-d1ecbc4d1b56517bf14d1595a37bee69.jpg";